import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles(
  theme => ({
    spacer: ({ spacing = 3 }: FormSpacerProps) => ({
      marginTop: theme.spacing(spacing)
    })
  }),
  { name: "FormSpacer" }
);

interface FormSpacerProps {
  children?: React.ReactNode;
  spacing?: number;
}

export const FormSpacer: React.FC<FormSpacerProps> = props => {
  const { children } = props;

  const classes = useStyles(props);

  return <div className={classes.spacer}>{children}</div>;
};

FormSpacer.displayName = "FormSpacer";
export default FormSpacer;
